/* eslint-disable */
import React, { Component } from 'react'
// import PropTypes from 'prop-types';
import { View, Image, TouchableHighlight, TouchableOpacity, Platform } from 'react-native'

import { Images } from '../Themes/'
import styles from './Styles/ListItemArrowIconStyle';
import { Container, Icon, Header, Content, ListItem, CheckBox, Thumbnail, Text, Left, Body, Right } from 'native-base';
export default class ListItemArrowIcon extends Component {


  render() {

    const { borderBottomWidth = 0.5, text = ``, children = null } = this.props
    const { extraTextStyle = {} } = this.props

    const forNative =  Platform.OS != 'web' ? (

      <ListItem button onPress={this.props.onCellPress} style={{ height: 44, marginLeft: 0, 
        borderBottomWidth: borderBottomWidth }}>
        {!children && <Text style={[styles.textStyle, extraTextStyle]}>{text}</Text>}
        {children && <Text style={[styles.textStyle, extraTextStyle]}>{children}</Text>}
        <Body>

        </Body>
        <Right >
          {this.props.withArrow && <Thumbnail style={styles.image} source={Images.disclosure} />}
        </Right>
      </ListItem>

    ) : null

    const forWeb = (

      <Text onPress={this.props.onCellPress} style={{ height: 44, marginLeft: 0, 
        borderBottomWidth: borderBottomWidth }}>
        {!children && <Text style={[styles.textStyle, extraTextStyle]}>{text}</Text>}
        {children && <Text style={[styles.textStyle, extraTextStyle]}>{children}</Text>}
        <View>

        </View>
        <View style={{position: 'absolute', right: 20}}>
          {this.props.withArrow && <Image style={styles.image} source={Images.disclosure} />}
        </View>
      </Text>

    )

    const toShow = Platform.OS == 'web' ? forWeb : forNative

    return (
      forWeb
    )
  }
}
